import React, { useState, useEffect } from "react";
import LeftIndent from "utils/LeftIndent";
import ConfigTabs from "../ConfigTabs";
import { Tab, Nav, Container, Form, Row, Col } from "react-bootstrap";
import updateParams from "utils/updateParams.js";
import Alerts from "./alerts/Alerts";
import Dashboard from "./dashboard/Dashboard";
import Goals from "./goals/Goals";
import IDs from "./ids/IDs";
import KeywordGroups from "./keyword_groups/KeywordGroups";
import SaveChanges from "client_config/SaveChanges";
import LandingPages from "./landing_pages/LandingPages";
import jsDig from "utils/jsDig";
import dismissDataPullErrors from "utils/dismissDataPullErrors";
import { capitalize, uniq } from "lodash-es";

export default function SEOConfig(props) {
  const [tabLocation, setTabLocation] = useState("");
  const formSubmitUrl = "/datapulse/seo-config";
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;
  const seoPulling =
    (jsDig(["data_pull_status", "google_data_pull"], props.seo_section) && jsDig(["data_pull_status", "google_data_pull"], props.seo_section).length > 0) ||
    (jsDig(["data_pull_status", "search_console_data_pull"], props.seo_section) && jsDig(["data_pull_status", "search_console_data_pull"], props.seo_section).length > 0) ||
    (jsDig(["data_pull_status", "semrush_data_pull"], props.seo_section) && jsDig(["data_pull_status", "semrush_data_pull"], props.seo_section).length > 0);
    const seoRecalculating =
    (jsDig(["data_pull_status", "recalculation"], props.seo) && jsDig(["data_pull_status", "recalculation"], props.seo).length > 0)

  const [showErrors, setShowErrors] = useState((jsDig(["data_pull_errors"], props.seo_section) && Object.keys(jsDig(["data_pull_errors"], props.seo_section)).length > 0) ? true : false)

  useEffect(() => {
    let searchParams = new URL(location.href).searchParams;
    let page = searchParams.get("page");
    if (!page || page == "") {
      page = "ids";
    }
    setTabLocation(page);
    updateParams("page", page);
  }, []);

  const selectTab = (key) => {
    setTabLocation(key);
    updateParams("page", key);
  };

  const pullInProgress = () => {
    return (
      <div className="spin-shell">
        <div className="spin-container">
          <div className="spinner">
            <img src="https://marcopolo.me/static/images/loading.png" />
          </div>
          <div className="title">
            <span>A data pull is in progress.</span>
          </div>
          <div className="description">
            <p>This page is not available while the data pull is in progress.</p>
            <span></span> Please check back later or
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                location.reload();
              }}>
              {" "}
              <b>refresh </b>
            </span>
            <span>the page.</span>
          </div>
        </div>
      </div>
    );
  };

  const recalcInProgress = () => {
    return (
      <div className="spin-shell">
        <div className="spin-container">
          <div className="spinner">
            <img src="https://marcopolo.me/static/images/loading.png" />
          </div>
          <div className="title">
            <span>Data is being recalculated.</span>
          </div>
          <div className="description">
            <p>Your data pull has completed but data is recalculating</p>
            <span>Please be patient {props.current_user ? props.current_user.first_name : "my guy"} and check back later or</span>
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                location.reload();
              }}>
              {" "}
              <b>refresh </b>
            </span>
            <span>the page.</span>
          </div>
        </div>
      </div>
    );
  };

  const displayErrors = () => {
    return (
      <div className="spin-shell">
        <div className="spin-container" style={{height: "auto"}}>
          <div className="title text-danger">
            <span>There were errors on the last data pull</span>
          </div>
          <div className="description">
            {props.seo_section.data_pull_errors && Object.keys(props.seo_section.data_pull_errors).map((platform) => {
              const errorCounts = props.seo_section.data_pull_errors[platform].reduce((map, val) => {map[val] = (map[val] || 0)+1; return map}, {} );
              return (
                <React.Fragment key={platform}>
                  <div style={{paddingTop: "30px"}}>
                    <h3 className="text-danger" style={{textAlign: "left"}}>{capitalize(platform)}:</h3>
                    <ul style={{listStyle: "none", textAlign: "left", paddingLeft: "10px"}}>
                      {uniq(props.seo_section.data_pull_errors[platform]).map((errorMessage, index) => {
                        const length = errorCounts[errorMessage];
                        return (
                          <li key={index}>- {length > 1 ? `(${length}x) ` : ' '}{errorMessage}</li>
                        )
                      })}
                    </ul>
                  </div>
                </React.Fragment>
              )
            })}
            <div className="d-flex justify-content-center">
            <button
              className="btn btn-info mx-2"
              onClick={(e) => {
                e.preventDefault()
                dismissDataPullErrors(jsDig(["id"], props.seo_section), "seo")
                $(e.target).closest('.spin-container').fadeOut();
                setTimeout(() => {
                  location.reload()
                }, 1000)
              }}>
              Dismiss
            </button>
          </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <ConfigTabs enabledServices={props.enabled_services} selectedTab="seo" />
      {seoPulling ? (
        pullInProgress()
      ) : seoRecalculating ? (
        recalcInProgress()
      ) : showErrors ? (
        displayErrors()
      ) : (
        <Row className="styled-indent-green">
          <Col className="px-md-3">
            <Form id="seo-config-form" className="client-config-content" method="post" encType="multipart/form-data" action={formSubmitUrl}>
              <Container fluid style={{ backgroundColor: "#E1E1E1" }}>
                <SaveChanges userIsAdmin={props.user_is_admin} seo />
                <input hidden name="client_account_id" value={props.client_account.id} readOnly />
                <input hidden name="selected_page" value={tabLocation} readOnly />
                <input hidden name="authenticity_token" value={authenticityToken} readOnly />
                <Tab.Container id="SEO-config-tabs" defaultActiveKey="ids" activeKey={tabLocation} onSelect={(k) => selectTab(k)}>
                  <Nav variant="pills" className="pt-0 px-md-5 pb-0 nav-fill tabs-navigation-2 row no-gutters row-cols-sm-1 row-cols-md-2 row-cols-lg-6">
                    <Nav.Item className="col">
                      <Nav.Link eventKey="ids" style={{ whiteSpace: "nowrap" }} data-link-type="page">
                        IDs and Data
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="col">
                      <Nav.Link eventKey="landing_pages" style={{ whiteSpace: "nowrap" }} data-link-type="page">
                        Landing Pages
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="col">
                      <Nav.Link eventKey="keyword_groups" data-link-type="page">Keyword Groups</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="col">
                      <Nav.Link eventKey="goals" data-link-type="page">Goals</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="col">
                      <Nav.Link eventKey="dashboard" data-link-type="page">Dashboard</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="col">
                      <Nav.Link eventKey="alerts" data-link-type="page">Alerts</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane className="px-md-5 trim-margin" eventKey="ids">
                      <IDs {...props} />
                    </Tab.Pane>
                    <Tab.Pane className="px-md-5 trim-margin" eventKey="landing_pages">
                      <LandingPages {...props} />
                    </Tab.Pane>
                    <Tab.Pane className="px-md-5 trim-margin" eventKey="keyword_groups">
                      <KeywordGroups {...props} keywordGroups={props.keyword_groups} />
                    </Tab.Pane>
                    <Tab.Pane className="px-md-5 trim-margin" eventKey="goals">
                      <Goals {...props} />
                    </Tab.Pane>
                    <Tab.Pane className="px-md-5 trim-margin" eventKey="dashboard">
                      <Dashboard {...props} />
                    </Tab.Pane>
                    <Tab.Pane className="px-md-5 trim-margin" eventKey="alerts">
                      <Alerts {...props} />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Container>
            </Form>
          </Col>
        </Row>
      )}
    </>
  );
}
